import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {DialogModule} from '@syncfusion/ej2-angular-popups';
import {DialogService} from '../../../shared/services/dialog.service';
import {HeadlineComponent} from '../../../shared/elements/headline/headline.component';
import {TranslatePipe} from '../../../shared/pipes/translate.pipe';
import {TooltipComponent} from "../../../shared/elements/tooltip/tooltip.component";
import {ContentComponent} from "../../../shared/elements/content/content.component";

@Component({
  selector: 'app-assistance-dialog',
  imports: [
    DialogModule,
    HeadlineComponent,
    TranslatePipe,
    TooltipComponent,
    ContentComponent
],
  templateUrl: './assistance-dialog.component.html',
  styleUrl: './assistance-dialog.component.scss'
})
export class AssistanceDialogComponent {
  public dialogService: DialogService = inject(DialogService);

  @Input() public visible: boolean = false;
  @Output() public visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  public assistanceUrl: string = 'https://assist.humanstars.app';
  public calendarUrl: string = 'https://calendly.com/msi-humanstars/30min';

  public close(): void {
    this.visibleChange.emit(false);
  }
}